// extracted by mini-css-extract-plugin
export default {"date":"hEojLS"};